<template>
    <v-row class="row--large">
        <v-col cols="4" lg="auto" v-for="{ text, value } in items" :key="text">
            <v-sheet>
                <p class="page-text--sm grey-9--text mb-4">{{ text }}</p>
                <h5 class="page-text--lg font-weight-medium">{{ value }}명</h5>
                <!-- <v-card-subtitle class="pa-0">{{ text }}</v-card-subtitle>
                <v-card-title class="pa-0 pt-14">{{ value }}명</v-card-title> -->
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        item: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            return [
                { text: "지원자수", value: this.item?.meta?.count?.applications || 0 },
                { text: "신규지원자", value: this.item?.meta?.count?.newApplications || 0 },
                { text: "합격자", value: this.item?.meta?.count?.recruits || 0 },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep .v-sheet {
        width: 68px;
        max-width: 68px;
    }
}
@media (min-width: 1200px) {
}
</style>
